import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, withModifiers as _withModifiers, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24eaaa93"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "address" }
const _hoisted_2 = { class: "addr-item" }
const _hoisted_3 = { class: "addr-phone-name" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "addr-item-addrinfo" }
const _hoisted_7 = {
  key: 0,
  class: "addr-item-kind"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 0,
  class: "multiple"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "Use this address", -1))
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Delete")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Edit")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!$props.item.true_name)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
              _createVNode(_component_van_icon, {
                name: "manager",
                color: "#666666"
              }),
              _createTextVNode(" " + _toDisplayString($props.item.firstname) + " " + _toDisplayString($props.item.lastname), 1)
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_5, [
              _createVNode(_component_van_icon, {
                name: "manager",
                color: "#666666"
              }),
              _createTextVNode(" " + _toDisplayString($props.item.true_name), 1)
            ])),
        _createElementVNode("span", null, "+ " + _toDisplayString($props.item.area_code) + " " + _toDisplayString($props.item.phone), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        ($props.item.area_info)
          ? (_openBlock(), _createBlock(_component_van_icon, {
              key: 0,
              name: "location",
              color: "#666666"
            }))
          : _createCommentVNode("", true),
        _createElementVNode("span", null, _toDisplayString($props.item.area_info ? ($props.item.area_info + ',' + $props.item.address) : ' ' + $props.item.address), 1)
      ]),
      ($props.address_message)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            ($props.item.is_default == '1')
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, "[Default]"))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createElementVNode("div", {
      class: "addr-item-bot",
      onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.place_rder_fnc($props.item)))
    }, [
      ($setup.is_checkout || Number($setup.isShowCheck))
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            ($setup.isFiltrate === '1')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  ($props.item.address_id == $setup.isShowCheck&&!$props.item.dlyp_id&&$props.item.area_pickup)
                    ? (_openBlock(), _createBlock(_component_van_icon, {
                        key: 0,
                        name: "checked",
                        color: "#f76900",
                        size: "22"
                      }))
                    : (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        class: _normalizeClass($props.item.dlyp_id > 0 || !$props.item.area_pickup ? 'disabled-item':'')
                      }, null, 2))
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  ($props.item.address_id == $setup.is_checkout||$props.item.address_id == $setup.isShowCheck)
                    ? (_openBlock(), _createBlock(_component_van_icon, {
                        key: 0,
                        name: "checked",
                        color: "#f76900",
                        size: "22"
                      }))
                    : (_openBlock(), _createElementBlock("span", _hoisted_10))
                ], 64)),
            _hoisted_11
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_12)),
      (!$setup.is_checkout&&!Number($setup.isShowCheck))
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createVNode(_component_van_button, {
              type: "default",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.removeAddr($props.item)), ["stop"]))
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            }),
            _createVNode(_component_van_button, {
              type: "default",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => ($setup.compileEdit($props.item)), ["stop"]))
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, $props.address_message]
    ])
  ]))
}